import styled from '@emotion/styled';

export const StyledLink = styled.span`
    a {
        text-decoration: none;
    }
`;
